module.exports = __webpack_public_path__ + "./docs/img/icon-constructor.8c2cfe92386b16d5f36a6107e1fba474.svg";